package chand.wordvoyage.data

import kotlinx.serialization.Serializable

@Serializable
data class WordEntry(
    val word: String = "",
    val meaning: String = "",
    val howToPronounce: String = "",
    val wordUsage: String = "",
    val examplesOfUsingWord: List<String> = emptyList(),
    val websiteLinkToStillMoreInfo: String = "",
    val savedAt: Long = 0L  // epoch millis
)

